import { gql } from 'graphql-tag'
import fragmentBlockContent from '../../../../core/data-layer/blocks/block-content/fragment-block-content'

export default gql`
  ${fragmentBlockContent}
  fragment PageIndexChapter2025Fragment on PageIndexChapter2025 {
    hero {
      ...BlockContentFragment
    }
    bentoCardTitle
    bentoCardDescription
    slug
  }
`
